import { NgModule, Optional, SkipSelf } from '@angular/core';
import { CommonModule } from '@angular/common';
import { RouterModule } from '@angular/router';

import { SharedModule } from './shared.module';
import { HeaderComponent, FooterComponent, SkeletonComponent,MenuComponent,
  DashboardComponent, UserInfoComponent } from '../components';
import { UsersModule } from './users.module';


@NgModule({
  declarations: [
   HeaderComponent,
   FooterComponent,
   SkeletonComponent,
   MenuComponent
  ],
  exports: [
   HeaderComponent,
   FooterComponent,
   SkeletonComponent,
   MenuComponent
  ],
  imports: [
    RouterModule,
    CommonModule,
    SharedModule,
    UsersModule
  ],

})
export class CoreTemplateModule {
  constructor(@Optional() @SkipSelf() parentModule: CoreTemplateModule) {
    if (parentModule) {
      throw new Error('CoreModule is already loaded. Import it in the AppModule only');
    }
  }
 }

